import { getCompaniesForFilters } from 'api/companies'

export * from './position'
export * from './positionTemplate'
export * from './positionTemplates'

export type GetCompaniesParams = Parameters<typeof getCompaniesForFilters>[0]

// TODO: Used by two remaining pages
export const getCompanies = getCompaniesForFilters
